import { Autocomplete, Button, Paper, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Field, FieldArray } from 'formik';
import React from 'react';
import RadioYN from './RadioYN';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

export default function SibilingsFamilyHomeDetailsSection({
  values,
  setFieldValue,
  classes,
  errors,
  touched,
  loading,
}) {
  return (
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" mb={6}>
        Siblings , Family & Home Details
      </Typography>
      <Box display={'flex'} gap={2} flexDirection={'column'} maxWidth={900}>
        <RadioYN
          label={'Do you have Sibilings ?'}
          sx={{
            alignSelf: 'flex-start',
            minWidth: 250,
          }}
          value={values?.hasSiblings}
          data={[
            { label: 'Yes', value: 1 },
            { label: 'No', value: 0 },
          ]}
          onChange={(e) => setFieldValue('hasSiblings', e)}
        />
        {Boolean(Number(values.hasSiblings)) && (
          <Box display={'flex'} flexDirection={'column'} gap={2} width={'100%'}>
            <FieldArray name="siblings">
              {({ push, remove }) =>
                values.siblings.map((_, index) => (
                  <Box display={'flex'} gap={2} key={index} flexDirection={'column'} maxWidth={300}>
                    <Field as={TextField} label={'Name'} fullWidth name={`siblings[${index}].name`} />
                    <Box display={'flex'} gap={2}>
                      <Field as={TextField} type="number" label={'Age'} name={`siblings[${index}].age`} />
                      <Autocomplete
                        fullWidth
                        disabled={loading}
                        name="classId"
                        id="classId"
                        options={classes}
                        getOptionLabel={(option) => option.className || ''}
                        onChange={(_, v) => setFieldValue(`siblings[${index}].class`, v?.id)}
                        value={classes?.find((syllabus) => syllabus.id == values.siblings[index].class) || null}
                        renderInput={(params) => (
                          <Field as={TextField} disabled fullWidth autoComplete="off" {...params} label="Class" />
                        )}
                      />
                    </Box>

                    <Box display={'flex'} gap={2} justifyContent={'center'}>
                      <Button
                        variant="contained"
                        onClick={() => push({ name: '', age: '', class: '' })}
                        startIcon={<AddIcon />}
                      >
                        Add
                      </Button>
                      <Button variant="outlined" color="error" onClick={() => remove(index)} startIcon={<DeleteIcon />}>
                        Delete
                      </Button>
                    </Box>
                  </Box>
                ))
              }
            </FieldArray>
          </Box>
        )}
        <RadioYN
          sx={{
            width: { xs: '100%', sm: 250 },
          }}
          label={'Home Type'}
          onChange={(v) => setFieldValue('homeType', v)}
          value={values?.homeType}
          valueKey={'label'}
          data={[
            { label: 'Rented', value: 0 },
            { label: 'Owned', value: 1 },
          ]}
        />
        <Field
          as={TextField}
          label="Parents aspiration - Child"
          name="parentsAspirationChild"
          multiline
          rows={3}
          fullWidth
        />
      </Box>
    </Paper>
  );
}
